import { RefreshCw } from "lucide-react";
import { useTranslation } from "react-i18next";

import { useMeta } from "@/api/meta";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { formatDateTime } from "@/lib/format";

export function ServerStatusCard() {
  const { t, i18n } = useTranslation();
  const { data, isPending, isError, refetch, isFetching } = useMeta();

  return (
    <Card>
      <CardHeader className="flex-row items-start justify-between gap-3">
        <div>
          <CardTitle>{t("server.title")}</CardTitle>
          <CardDescription>{t("server.description")}</CardDescription>
        </div>
        {isPending ? (
          <Badge>{t("server.checking")}</Badge>
        ) : isError ? (
          <Badge variant="danger">{t("server.offline")}</Badge>
        ) : (
          <Badge variant="success">{t("server.online")}</Badge>
        )}
      </CardHeader>
      <CardContent>
        {isPending ? (
          <div className="flex flex-col gap-2">
            <Skeleton className="h-4 w-2/3" />
            <Skeleton className="h-4 w-1/2" />
            <Skeleton className="h-4 w-3/4" />
          </div>
        ) : isError ? (
          <Button variant="secondary" size="sm" onClick={() => void refetch()} disabled={isFetching}>
            <RefreshCw className={isFetching ? "animate-spin" : undefined} />
            {t("server.retry")}
          </Button>
        ) : (
          <dl className="grid grid-cols-[auto_1fr] gap-x-6 gap-y-2">
            <dt className="text-muted">{t("server.version")}</dt>
            <dd className="font-medium">{data.version}</dd>
            <dt className="text-muted">{t("server.commit")}</dt>
            <dd className="font-mono text-xs leading-5">{data.commit}</dd>
            <dt className="text-muted">{t("server.serverTime")}</dt>
            <dd className="tabular-nums">{formatDateTime(data.server_time, i18n.language)}</dd>
          </dl>
        )}
      </CardContent>
    </Card>
  );
}
